import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { MyApp } from 'src/app/api/helper/app';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { Adresse, AuftragsFormular, AuftragsKomponente, Kontakt } from 'src/app/api/model/swagger-model';
import { SystemService } from 'src/app/api/system.service';
import { LieferantSuchenComponent } from 'src/app/shared/components/lieferant-suchen/lieferant-suchen.component';
import { Auftragdetails } from '../../auftragdetails.helper';
import { KomponenteBase } from '../komponente';

const log = new Logger("AuftragLieferantComponent");

@Component({
    selector: 'auftrag-lieferant-komponente',
    templateUrl: './lieferant-komponente.component.html',
    styleUrls: ['./lieferant-komponente.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragLieferantComponent extends KomponenteBase implements OnInit, OnChanges {

    @ViewChild('map', { static: false }) mapDiv: ElementRef;

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;
    @Input() adresse: Adresse;

    @Output() lieferantChanged: EventEmitter<Adresse> = new EventEmitter();

    isModalSichtbar = false;

    constructor(
        private router: Router,
        private modalController: ModalController,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        super.ngOnInit();
        this.init();
    }

    init() {
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        this.init();
    }

    async onNavigationStarten() {
        log?.debug('onNavigationStarten');
        this.auftragdetails.starteNavigation(this.adresse);
    }

    async onAnrufen() {
        log?.debug('onAnrufen');
        this.auftragdetails.anrufen(this.adresse);
    }

    async onAdresseClicked() {
        log?.debug('onAdresseClicked', this.adresse);

        if (this.auftrag.IstNeuanlage) {
            this.onAdresseAendern();
            return;
        }

        const result = await this.auftragdetails.frageAdresseAktion(this.komponente, this.adresse);

        if (result && result.aktion) {
            switch (result.aktion) {
                case 'Anrufen':
                    const kontakt = result.data as Kontakt;
                    SystemService.instance.anrufenTelefonnummer(kontakt.Telefon);
                    break;

                case 'navigation':
                    this.starteNavigation();
                    break;

                case 'adresse-aendern':
                    this.onAdresseAendern();
                    break;
            }
        }
    }

    private async starteNavigation() {
        this.auftragdetails.starteNavigation(this.adresse);
    }

    onAdresseAendern() {
        this.auftragdetails.anzeigenAdresseAendern(this.adresse);
    }

    async onLieferantWaehlenClicked() {
        log?.info('onLieferantWaehlenClicked');

        const modal = await this.modalController.create({
            component: LieferantSuchenComponent,
            componentProps: {
            }
        });

        await modal.present();

        const result = await modal.onDidDismiss();

        if (result && result.data) {
            const neueAdresse = result.data as Adresse;

            if (neueAdresse.AdressNummer) {
                this.adresse.AdressNummer = neueAdresse.AdressNummer;
                this.adresse.Name1 = neueAdresse.Name1;
                this.adresse.Name2 = neueAdresse.Name2;
                this.adresse.Name3 = neueAdresse.Name3;
                this.adresse.BehoerdlicheNummer = neueAdresse.BehoerdlicheNummer;
                this.adresse.Strasse = neueAdresse.Strasse;
                this.adresse.PLZ = neueAdresse.PLZ;
                this.adresse.Ort = neueAdresse.Ort;
                this.adresse.LKZ = neueAdresse.LKZ;
                this.adresse.Ansprechpartner = neueAdresse.Ansprechpartner;
                this.adresse.Telefon = neueAdresse.Telefon;

                this.lieferantChanged.next(this.adresse);
            }
        }

        this.cdr.detectChanges();
    }
}
